import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiHeader, headerJson } from '@helpers/commonHeaders';
import { RequestRoutes } from '@constants/requestRoutes';
import { notificationTag } from '@constants/apiTags';
// import { IUnreadRejectedAppointmentsCount } from '@api/notification/types';

export const notificationAPI = createApi({
  reducerPath: 'notificationAPI',
  tagTypes: [notificationTag],
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_API_URL,
    prepareHeaders: apiHeader,
  }),
  endpoints: (build) => ({
    markAllNotificationsAsRead: build.mutation({
      query: ({ userId, appointmentIds }) => ({
        url: `${RequestRoutes.Notifications}/readAll`,
        method: 'POST',
        headers: headerJson,
        body: {
          user_id: userId,
          appointment_ids: appointmentIds,
        },
      }),
      invalidatesTags: [notificationTag],
    }),

    markNotificationAsRead: build.mutation({
      query: ({ userId, appointmentId }) => ({
        url: `${RequestRoutes.Notifications}/read`,
        method: 'POST',
        headers: headerJson,
        body: {
          user_id: userId,
          appointment_id: appointmentId,
        },
      }),
      invalidatesTags: [notificationTag],
    }),

    getReadOrDeletedNotifications: build.query({
      query: (userId) => ({
        url: `${RequestRoutes.Notifications}/getReadOrDeletedNotifications?user_id=${userId}`,
        method: 'GET',
        headers: headerJson,
      }),
    }),

    deleteNotification: build.mutation({
      query: ({ userId, appointmentId }) => ({
        url: `${RequestRoutes.Notifications}/delete`,
        method: 'POST',
        headers: headerJson,
        body: {
          user_id: userId,
          appointment_id: appointmentId,
        },
      }),
      invalidatesTags: [notificationTag],
    }),

    deleteAllNotifications: build.mutation({
      query: ({ userId, appointmentIds }) => ({
        url: `${RequestRoutes.Notifications}/deleteAll`,
        method: 'POST',
        headers: headerJson,
        body: {
          user_id: userId,
          appointment_ids: appointmentIds,
        },
      }),
      invalidatesTags: [notificationTag],
    }),
  }),
});

export const {
  useGetReadOrDeletedNotificationsQuery,
  useMarkNotificationAsReadMutation,
  useMarkAllNotificationsAsReadMutation,
  useDeleteNotificationMutation,
  useDeleteAllNotificationsMutation,
} = notificationAPI;
